import { render, staticRenderFns } from "./DesignOppositionForm.vue?vue&type=template&id=458a26e1&"
import script from "./DesignOppositionForm.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionForm.vue?vue&type=style&index=0&id=458a26e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports